import { Color, DirectionalLight, Vector3 } from "three";
import { ShadowConfig } from "./consts";
import { MapConfig } from "@objects/terrain";
class Directional {
    color;
    intensity;
    position;
    target;
    light;
    /**
     * Directional light.
     * @param scene the rendering scene.
     */
    constructor(scene) {
        this.color = new Color(0xffffff);
        this.intensity = 0.5;
        this.position = new Vector3(16, 96, 16);
        this.target = new Vector3(0, 0, 0);
        this.light = this.createLight();
        scene.add(this.light);
    }
    /**
     * Create and configure a directional Light object.
     * @returns the created light object.
     * @private
     */
    createLight() {
        const light = new DirectionalLight(this.color, this.intensity);
        light.position.copy(this.position);
        light.target.position.copy(this.target);
        light.castShadow = true;
        light.shadow.bias = ShadowConfig.BIAS;
        light.shadow.mapSize.width = ShadowConfig.MAP_SIZE.width;
        light.shadow.mapSize.height = ShadowConfig.MAP_SIZE.height;
        light.shadow.camera.left = MapConfig.GROUND_WIDTH / 2 + this.position.x;
        light.shadow.camera.right = MapConfig.GROUND_WIDTH / -2 - this.position.x;
        light.shadow.camera.top = MapConfig.GROUND_HEIGHT / 2 + this.position.z;
        light.shadow.camera.bottom = MapConfig.GROUND_HEIGHT / -2 - this.position.z;
        return light;
    }
    get getColor() {
        return this.color;
    }
    set setColor(color) {
        this.color = color;
        this.light.color = this.color;
    }
    get getIntensity() {
        return this.intensity;
    }
    set setIntensity(intensity) {
        this.intensity = intensity;
        this.light.intensity = this.intensity;
    }
}
export { Directional };
